/**
 * Created by mac on 12/23/20
 */

const GroundedView = cc.Node.extend({
    ctor: function (grounded, unitView) {
        this._super();

        this.grounded = grounded;
        this.unitView = unitView;

        this.restoreState(true);
    },

    restoreState: function (silent) {
        this.removeStates(silent);

        if (this.grounded.isOpened()) {
            this.setGroundedState(silent);
        } else {
            this.setFogState(silent);
        }
    },

    removeStates: function (silent) {
        this.unitView.sprite.setVisible(true);

        if (silent) {
            if (this.spine) {
                this.spine.removeFromParent();
            }
            if (this.bg) {
                this.bg.removeFromParent();
            }
            return;
        }

        cleverapps.effects.fire("merge.grounded.destroy");

        const movingNode = cleverapps.Scenes.GetMovingNode(this.unitView);

        if (this.spine) {
            this.spine.replaceParentSamePlace(movingNode);
            this.spine.setAnimation(0, "close", false);
            this.spine.setCompleteListenerRemove();
            this.spine = undefined;
        }

        if (this.bg) {
            this.bg.replaceParentSamePlace(movingNode);
            this.bg.setAnimation(0, "close", false);
            this.bg.setCompleteListenerRemove();
            this.bg = undefined;
        }
    },

    setGroundedState: function () {
        const animation = GroundedView.getAnimation(this.grounded.unit.x, this.grounded.unit.y);

        const spine = this.spine = new cleverapps.Spine(animation.animation);
        spine.setAnimation(0, "idle", true);
        spine.setAlignment(this.unitView.width / 2, this.unitView.height / 2);
        this.unitView.addChild(spine, cleverapps.styles.GroundedView.openedZOrder);

        const unitViewAnimation = this.unitView.getAnimation();
        if (unitViewAnimation && unitViewAnimation.hasAnimation("idle_web")) {
            UnitView.applyDefaultAnimation(this.unitView.sprite, this.grounded.unit, "idle_web");
        } else {
            this.unitView.setImageOpacity(160);
        }

        if (animation.bg) {
            this.createBackground(animation.bg);
        }
    },

    createBackground: function (animation) {
        const bg = this.bg = new cleverapps.Spine(animation);
        bg.setAnimation(0, "idle", true);
        bg.setAlignment(this.unitView.width / 2, this.unitView.height / 2);
        this.unitView.addChild(bg, -1);
    },

    onStartMergeHint: function () {
        const movingNode = cleverapps.Scenes.GetMovingNode(this);

        if (this.spine) {
            if (this.grounded.isOpened() && cleverapps.styles.GroundedView.openedZOrder < 0) {
                this.spine.replaceParentSamePlace(this.unitView.parent);
                this.spine.setLocalZOrder(this.unitView.getLocalZOrder() + cleverapps.styles.GroundedView.openedZOrder);
            } else {
                this.spine.replaceParentSamePlace(movingNode);
            }
        }

        if (this.bg) {
            this.bg.replaceParentSamePlace(movingNode);
        }
    },

    onStopMergeHint: function () {
        if (this.spine) {
            this.spine.replaceParentSamePlace(this.unitView);
            this.spine.setLocalZOrder(this.grounded.isOpened() ? cleverapps.styles.GroundedView.openedZOrder : 0);
            this.spine.setAlignment(this.unitView.width / 2, this.unitView.height / 2);
            if (!this.grounded.isOpened()) {
                this.alignFog();
            }
        }

        if (this.bg) {
            this.bg.replaceParentSamePlace(this.unitView);
            this.bg.setAlignment(this.unitView.width / 2, this.unitView.height / 2);
        }
    },

    onExit: function () {
        this.onStopMergeHint();
    },

    setFogState: function () {
        this.unitView.sprite.setVisible(false);

        if (cleverapps.styles.GroundedView.fogBackground) {
            const animation = GroundedView.getAnimation(this.grounded.unit.x, this.grounded.unit.y);
            this.createBackground(animation.animation);
        }

        this.spine = new cleverapps.Spine(this.getFogImage());
        this.spine.setAnimation(0, "idle", true);
        this.alignFog();
        this.unitView.addChild(this.spine);
    },

    alignFog: function () {
        this.spine.setAlignment(this.unitView.width / 2, this.unitView.height / 2);

        if (this.grounded.unit.findComponent(FieldReward)) {
            const styles = cleverapps.styles.GroundedView.rewardFog;
            this.spine.setScale(styles.scale);
            this.spine.setAlignment(this.unitView.width / 2 + styles.offset.x, this.unitView.height / 2 + styles.offset.y);
        }
    },

    getFogImage: function () {
        const images = [1, 2, 3, 4].map((num) => bundles.merge.jsons[`fog${num}_json`]).filter(Boolean);

        if (images.length === 1) {
            return images[0];
        }

        const pseudo = PseudoRandom.GET("grounded");
        pseudo.seed(this.grounded.unit.x * 1000 + this.grounded.unit.y);
        return images[pseudo.random(0, images.length - 1)];
    },

    canSmile: function () {
        return this.spine && this.spine.getCurrentAnimationName(0) === "idle" && this.spine.hasAnimation("smile");
    },

    smile: function () {
        this.spine.setAnimationAndIdleAfter("smile", "idle");
    }
});

GroundedView.getAnimation = function (x, y) {
    let index = 1;
    while (bundles.fogs_garden.jsons[`ground_fog${index}`]) {
        index++;
    }

    const pseudo = PseudoRandom.GET("grounded");
    pseudo.seed(10 * x + y);
    const randomType = pseudo.random(1, index - 1);
    const animation = {
        animation: bundles.fogs_garden.jsons[`ground_fog${randomType}`]
    };
    if (bundles.fogs_garden.jsons[`ground_fog${randomType}_bg`]) {
        animation.bg = bundles.fogs_garden.jsons[`ground_fog${randomType}_bg`];
    }

    return animation;
};

cleverapps.styles.GroundedView = {
    fogBackground: false,
    openedZOrder: 0,

    rewardFog: {
        scale: 1,
        offset: {
            x: 0,
            y: 0
        }
    }
};
